import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, SubEventDeleteRequest, SubEventGetListRequest, SubEventGetListResponse, SubEventInsertRequest } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SubEventService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllSubEvents(body: SubEventGetListRequest) {
    const link = this.apiUrl + ApiUrls.getSubEvents;
    return this.http.post<SubEventGetListResponse>(link, body);
  }

  getSubEvent(id: any) {
    const link = this.apiUrl + ApiUrls.getSubEvent;
    return this.http.get<any>(link+"/"+ id);
  }

  deleteSubEvent(body: SubEventDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteSubEvent;
    return this.http.post<BaseResponse>(link, body);
  }

  insertSubEvent(body: FormData) {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });
    const link = this.apiUrl + ApiUrls.insertSubEvent;
    return this.http.post<BaseResponse>(link, body,{headers:headers});
  }
  
  updateSubEvent(body: SubEventInsertRequest) {
    const link = this.apiUrl + ApiUrls.updateSubEvent;
    return this.http.post<BaseResponse>(link, body);
  }

  createEventSeatMapping(body:any){
    const link = this.apiUrl + ApiUrls.createSeatMapping;
    return this.http.post<BaseResponse>(link, body);
  }

  updateEventSeatMapping(body:any){
    const link = this.apiUrl + ApiUrls.updateSeatMapping;
    return this.http.post<BaseResponse>(link, body);
  }

  getEventSeatMappingList(body:any){
    const link = this.apiUrl + ApiUrls.getEventSeatMapping;
    return this.http.post<SubEventGetListResponse>(link, body);
  }

  deleteSeatMapping(body:any){
    const link = this.apiUrl + ApiUrls.deleteEventSeatMapping;
    return this.http.post<BaseResponse>(link, body);
  }

  createUpdateEventSeatMapping(body:any){
    const link = this.apiUrl + ApiUrls.createUpdateSeatMapping;
    return this.http.post<BaseResponse>(link, body);
  }
}
